<template>
<div class="about">
  <v-layout row class="mx-2">
    <v-flex md6 class="pl-1 pr-1">
      <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field :error-messages="erroDate" standard v-model="dateFormatted" label="Data inicial" readonly v-on="on"></v-text-field>
        </template>
        <v-date-picker locale="PT-br" ref="picker" v-model="date" :max="maxDate" min="1950-01-01" @change="save"></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex md6 class="pl-1">
      <v-menu :disabled="date == null" ref="menuEnd" v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field :error-messages="erroDate" standard v-model="dateFormattedEnd" label="Data final" readonly v-on="on"></v-text-field>
        </template>
        <v-date-picker locale="PT-br" ref="pickerEnd" v-model="dateEnd" :min="new Date(date).toISOString().substr(0, 10)" :max="minDate" @change="saveEnd"></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import {
  EventBus
} from './../main'

export default {
  name: 'dateForm',
  props: {
    data: Object
  },
  data () {
    return {
      dateFormatted: '',
      date: null,
      dateDias: [],
      menu: false,
      menuEnd: false,
      maxDate: '',
      minDate: '',
      dateFormattedEnd: '',
      dateEnd: null,
      erroDate: '',
      load: false
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    date (val) {
      this.dateEnd = null
      this.dateFormatted = this.formatDate(this.date)
      this.corrigirDataMinima()
    },
    menuEnd (val) {
      val && setTimeout(() => (this.$refs.pickerEnd.activePicker = 'YEAR'))
    },
    dateEnd (val) {
      this.dateFormattedEnd = this.formatDate(this.dateEnd)
    }
  },
  methods: {
    save (date) {
      this.$refs.menu.save(date)
      this.$emit('dataInicio', date)
    },
    saveEnd (date) {
      this.$refs.menuEnd.save(date)
      this.$emit('dataFim', date)
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    corrigirDataMinima () {
      var hoje = new Date(this.date)
      var agora = new Date()
      var limite = new Date(hoje.getTime())
      limite.setDate(hoje.getDate() + this.data.intervaloDias)

      var dd = limite.getDate()
      var mm = limite.getMonth() + 1
      var yyyy = limite.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }
      this.minDate = yyyy + '-' + mm + '-' + dd
      var mDate = new Date(this.minDate)
      this.maxDate = new Date()
      if (this.data.isDataFutura) {
        this.maxDate = new Date(this.maxDate.getFullYear() + 1 + '-' + 12 + '-' + 31)
        this.maxDate = this.maxDate.toISOString().substr(0, 10)
      } else {
        if (agora < mDate) {
          dd = agora.getDate()
          mm = agora.getMonth() + 1
          yyyy = agora.getFullYear()

          if (dd < 10) {
            dd = '0' + dd
          }

          if (mm < 10) {
            mm = '0' + mm
          }
          this.minDate = yyyy + '-' + mm + '-' + dd
        }
      }
    }
  },
  mounted () {
    EventBus.$on('filtro', this.corrigirDataMinima())
  }
}
</script>
